import FormattedMessage from 'I18n/components/FormattedMessage';
import { ModalPanel } from 'foundations-components/transitional/components/ModalPanel';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { H4 } from 'foundations-components/transitional/components/H4';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';

// @ts-expect-error: no types
import { useHideDialog } from '../../../dialog/ducks';
import { ShareViaWizardSteps } from '../constants';
import SharingMethodStepContainer from './SharingMethodStep/SharingMethodStepContainer';
import ConfigurationStepContainer from './ConfigurationStep/ConfigurationStepContainer';
import { useShareViaSettings } from './ShareViaSettingsContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ShareViaContentSteps = {
  [ShareViaWizardSteps.sharingMethodStep]: SharingMethodStepContainer,
  [ShareViaWizardSteps.configurationStep]: ConfigurationStepContainer
};
const ShareViaDialog = () => {
  const hideDialog = useHideDialog();
  const {
    stepIndex
  } = useShareViaSettings();
  const ShareViaContent = ShareViaContentSteps[stepIndex];
  return /*#__PURE__*/_jsxs(ModalPanel, {
    "data-test-id": "share-report-dialog",
    width: 600,
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.shareVia.dialog.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: hideDialog
      })]
    }), /*#__PURE__*/_jsx(ShareViaContent, {})]
  });
};
export default ShareViaDialog;